export const SESSION_KEY = 'boostSdSessionId';
export const QUERY_STRING_KEY = 'boostSdQueryString';
export const PRE_ACTION = 'boostSdPreAction';
export const PRE_REQUEST_IDS = 'boostSdPreRequestIds';
export const CLICK_SUGGESTION_TERM = 'boostSDClickSuggestionTerm';
export const SUGGESTION_DATA = 'boostSDSuggestionData';

export const MOBILE_BREAKPOINT = 767;
